import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { Middleware } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    console.error("Full error payload:", action.payload);
    
    const errorStatus = action.payload?.status || 'Unknown';
    const errorMessage = action.payload?.data?.message || 'No message provided';
    const errorTimestamp = new Date().toISOString(); 
    
    console.warn(`Error occurred at: ${errorTimestamp}`);
    console.warn(`Error Status: ${errorStatus}`);
    console.warn(`Error Message: ${errorMessage}`);
    
    if (action.meta?.baseQueryMeta) {
      console.warn("Request Details:", {
        url: action.meta.baseQueryMeta.request.url,
        method: action.meta.baseQueryMeta.request.method,
        headers: action.meta.baseQueryMeta.request.headers,
      });
    }
    
    if (errorStatus === 'FETCH_ERROR') {
      toast.error(`Network Error: unable to connect to API`);
    } else {
      toast.error(`${errorStatus} Error: ${errorMessage}`);
    }
  }

  return next(action);
};
